var _style, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarNew02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FDBA74;}\n\t.st1{fill:#606060;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 40,
    height: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.44,22.51c-2.58-0.57-4.51-1.95-5.77-4.22c-0.96-1.73-1.23-3.59-0.85-5.53c0.76-3.91,4.22-6.73,8.19-6.7 c3.95,0.03,7.41,2.92,8.08,6.75c0.39,2.24-0.02,4.32-1.31,6.2c-1.28,1.86-3.06,3.01-5.27,3.49c1.48,0.17,2.92,0.5,4.29,1.07 c4.53,1.89,7.55,5.18,9.1,9.83c0.16,0.48-0.01,0.86-0.42,1c-0.41,0.14-0.78-0.08-0.93-0.56c-0.73-2.28-1.92-4.27-3.64-5.93 c-2.25-2.18-4.93-3.52-8.04-3.89c-5.07-0.6-9.34,1.01-12.74,4.83c-1.24,1.39-2.1,3.01-2.69,4.78c-0.04,0.11-0.07,0.22-0.11,0.32 c-0.16,0.4-0.51,0.58-0.89,0.45c-0.39-0.13-0.6-0.51-0.45-0.91c0.3-0.81,0.57-1.64,0.96-2.4c2.32-4.51,5.98-7.28,10.93-8.35 C17.37,22.65,17.88,22.6,18.44,22.51z M19.95,21.2c3.78,0.01,6.86-3.06,6.86-6.84c0-3.77-3.07-6.86-6.85-6.87 c-3.77-0.01-6.86,3.08-6.86,6.85C13.1,18.12,16.16,21.19,19.95,21.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarNew02);
export default __webpack_public_path__ + "static/media/Avatar_new_02.03ee9f64805ed3a3e9c3975a7e1f2b02.svg";
export { ForwardRef as ReactComponent };